export default {
    name: 'TableHeader',
    data () {
        return {
            showCommitColumns: window.gon?.show_commit_columns !== false
        };
    }
};
